import React, { useContext, useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

import FolderList from "../components/FolderList";
import AdminDashboard from "../components/AdminDashboard";
import HomeWidgets from "../components/HomeWidgets";
import "./AdminHome.css";

function AdminHome() {
  const { user } = useContext(AuthContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [currentFolderId, setCurrentFolderId] = useState("root");
  const [currentFolderPath, setCurrentFolderPath] = useState("root");

  // Determine active view from URL query params
  const tab = searchParams.get("tab") || "home";

  useEffect(() => {
    console.log("Logged in admin:", user);
  }, [user]);

  // Handle deep linking for folders
  useEffect(() => {
    const tabParam = searchParams.get("tab") || "home";
    const folderId = searchParams.get("folderId");

    if (tabParam !== "files") return;

    // URL is the source of truth for folder deep-linking.
    // If no folderId is present, we must stay at root.
    if (folderId) {
      setCurrentFolderId((prev) => (prev === folderId ? prev : folderId));
    } else {
      setCurrentFolderId((prev) => (prev === "root" ? prev : "root"));
      setCurrentFolderPath((prev) => (prev === "root" ? prev : "root"));
    }
  }, [searchParams]);

  const handleFolderChange = (newId) => {
    setCurrentFolderId(newId);
    if (newId === "root") {
      setSearchParams({ tab: "files" });
    } else {
      setSearchParams({ tab: "files", folderId: newId });
    }
  };

  const handleWidgetNavigate = (targetRoute) => {
    if (targetRoute === "/admin?tab=files" || targetRoute === "/employee?tab=files") {
      setSearchParams({ tab: "files" });
      setCurrentFolderId("root");
    } else if (targetRoute) {
      navigate(targetRoute);
    }
  };

  if (!user) return null;

  return (
    <>
      {tab === "home" && (
        <HomeWidgets onNavigate={handleWidgetNavigate} isAdmin={true} />
      )}

      {tab === "dashboard" && (
        <AdminDashboard />
      )}

      {tab === "files" && (
        <FolderList
          currentFolderId={currentFolderId}
          currentFolderPath={currentFolderPath}
          setCurrentFolderId={handleFolderChange}
          setCurrentFolderPath={setCurrentFolderPath}
          user={user}
          employeeId={user?.employeeId}
          mode="admin"
        />
      )}
    </>
  );
}

export default AdminHome;
